module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "logo-section"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "108px"
    },
    attrs: {
      "src": require("../assets/logo.png")
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "16px"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": require("../assets/u_logo.gif")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-center"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center",
      "color": "#6C7A80"
    }
  }, [_vm._v("\n                            ฐานข้อมูลเห็ดพิษ\n                        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center",
      "color": "#6C7A80",
      "font-size": "18px"
    }
  }, [_vm._v("\n                            กรมวิทยาศาสตร์การแพทย์ ร่วมกับ มหาวิทยาลัยมหาสารคาม\n                        ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c6306f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebHeader.vue
// module id = 1092
// module chunks = 1